import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";

export const HomeBanner = () => {
  const [BannerUser, setBannerUser] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      const response = await axios.get("https://admin.gosaviadvanceddentalclinic.com/api/getbanner");
      setBannerUser(response.data);
    };

    fetchData();
  }, []);

  const deleteUser = async (userId) => {
    try {
      await axios.delete(`https://admin.gosaviadvanceddentalclinic.com/api/deletebanner/${userId}`);

      setBannerUser(
        (prevUsers) => prevUsers.filter((user) => user.id !== userId) // Use `id` instead of `_id`
      );

      toast.error("Data Deleted Successfully!");
      navigate("/");
    } catch (error) {
      console.error("There was an error!", error);
      toast.error("Failed to delete data!");
    }
  };

  return (
    <div className="container homeBanner-details">
      <div className="row arpi">
        <div className="col-lg-2 col-md-2 col-sm-12"></div>

        <div className="col-lg-10 col-md-10 col-sm-12 view-home">
          <Link to="/banner-add">
            <button className="Banner-button">Add</button>
          </Link>

          {BannerUser.map((user) => {
            return (
              <div key={user.id}>
                {" "}
                <h3>
                  {user.heading}{" "}
                  <Link to={`/banner-edit/` + user.id}>
                    {" "}
                    <i className="fa-regular fa-pen-to-square action-sec"></i>
                  </Link>
                  <span onClick={() => deleteUser(user.id)}>
                    {" "}
                    <i
                      title="Delete"
                      className="fa-solid fa-trash-can action-sec"
                      style={{ color: "red" }}
                    ></i>
                  </span>
                </h3>{" "}
                <img
                  src={user.bannerimage}
                  alt="banner"
                  style={{ width: "700px", height: "500px" }}
                />
                <p dangerouslySetInnerHTML={{ __html: user.description }}></p>
                <hr />
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export const HomeBannerEdit = () => {
  const [Banneruser, setBannerUser] = useState({
    heading: "",
    description: "",
    bannerimage: "",
  });
  const [previewImage, setPreviewImage] = useState("");
  const [selectedImage, setSelectedImage] = useState(null);
  const { id } = useParams();
  const navigate = useNavigate();
  const [editorLoaded, setEditorLoaded] = useState(false);

  // ✅ Load CKEditor script dynamically
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://cdn.ckeditor.com/4.21.0/standard/ckeditor.js";
    script.async = true;
    script.onload = () => setEditorLoaded(true);
    document.body.appendChild(script);

    return () => {
      if (window.CKEDITOR) {
        Object.keys(window.CKEDITOR.instances).forEach((instance) => {
          window.CKEDITOR.instances[instance].destroy(true);
        });
      }
    };
  }, []);

  // ✅ Fetch banner data
  const fetchBannerData = async () => {
    try {
      const response = await axios.get(
        `https://admin.gosaviadvanceddentalclinic.com/api/getone/${id}`
      );
      if (response.data.success) {
        setBannerUser(response.data.data);

        if (window.CKEDITOR && window.CKEDITOR.instances.editor) {
          window.CKEDITOR.instances.editor.setData(
            response.data.data.description
          );
        }
      }
    } catch (error) {
      console.error("Error fetching banner data!", error);
      toast.error("Failed to load banner data.");
    }
  };

  useEffect(() => {
    if (editorLoaded) {
      fetchBannerData();
    }
  }, [id, editorLoaded]);

  useEffect(() => {
    if (editorLoaded && !window.CKEDITOR.instances.editor) {
      window.CKEDITOR.replace("editor");
    }
  }, [editorLoaded]);

  useEffect(() => {
    if (editorLoaded && window.CKEDITOR.instances.editor) {
      window.CKEDITOR.instances.editor.setData(Banneruser.description || "");
    }
  }, [Banneruser.description, editorLoaded]);

  useEffect(() => {
    if (Banneruser.bannerimage && typeof Banneruser.bannerimage === "string") {
      setPreviewImage(Banneruser.bannerimage);
    }
  }, [Banneruser.bannerimage]);

  const changeHandler = (e) => {
    const { name, value } = e.target;
    setBannerUser({ ...Banneruser, [name]: value });
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
  
    if (file) {
      const allowedTypes = ["image/jpg", "image/jpeg", "image/png", "image/webp"];
      const maxSize = 2 * 1024 * 1024; // 2MB
  
      // ✅ Type check
      if (!allowedTypes.includes(file.type)) {
        toast.error("Only JPG, JPEG, PNG, and WEBP files are allowed.");
        return;
      }
  
      // ✅ Size check
      if (file.size > maxSize) {
        toast.error("Image size should be under 2MB.");
        return;
      }
  
      // ✅ Optional: Dimension check (example: max 1920x1080)
      const img = new Image();
      const objectUrl = URL.createObjectURL(file);
      img.src = objectUrl;
  
      img.onload = () => {
        const { width, height } = img;
  
        // Example check (adjust if needed)
        if (width > 1350 || height > 700) {
          toast.error("Image dimensions should not exceed 1350x700.");
          URL.revokeObjectURL(objectUrl); // Clean up
          return;
        }
  
        setSelectedImage(file);
        const reader = new FileReader();
        reader.onloadend = () => {
          setPreviewImage(reader.result);
        };
        reader.readAsDataURL(file);
      };
    }
  };
  

  // ✅ Submit form data
  const submitForm = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("heading", Banneruser.heading);
    formData.append("description", window.CKEDITOR.instances.editor.getData());
    if (selectedImage) {
      formData.append("bannerimage", selectedImage);
    }

    try {
      const response = await axios.put(
        `https://admin.gosaviadvanceddentalclinic.com/api/updatebanner/${id}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.data.success) {
        toast.success("Data updated successfully!");
        navigate("/");
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.error("There was an error updating the banner!", error);
      toast.error("Failed to update banner.");
    }
  };

  return (
    <div
      className="modal fade show"
      id="update_heading"
      tabIndex={-1}
      style={{ display: "block", marginTop: 90, paddingBottom: 50 }}
      aria-modal="true"
    >
      <div className="modal-dialog">
        <form onSubmit={submitForm}>
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Edit</h5>
              <Link to="/">
                <button type="button" className="close">
                  <span aria-hidden="true">
                    <i className="fa-solid fa-xmark"></i>
                  </span>
                </button>
              </Link>
            </div>

            <div className="modal-body">
              <div className="form-group">
                <label>Heading</label>
                <input
                  type="text"
                  value={Banneruser.heading}
                  onChange={changeHandler}
                  className="form-control"
                  name="heading"
                  required
                />
                <br />
              </div>

              <div className="form-group">
                <label>Image</label>
                <input
                  type="file"
                  className="form-control"
                  name="bannerimage"
                  onChange={handleImageChange}
                  accept="image/*"
                />
                <br />
                {previewImage && (
                  <img
                    src={previewImage}
                    alt="Preview"
                    style={{
                      width: "100%",
                      height: "300px",
                    }}
                  />
                )}
              </div>

              <div className="form-group">
                <br />
                <label>Description</label>
                <textarea id="editor"></textarea>
              </div>
            </div>

            <div className="modal-footer">
              <Link to="/">
                <button type="button" className="btn btn-secondary">
                  Close
                </button>
              </Link>
              <button type="submit" className="btn btn-primary">
                Update
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export const BannerAdd = () => {
  const [bannerData, setBannerData] = useState({
    heading: "",
    description: "",
    bannerimage: null,
  });

  const [previewImage, setPreviewImage] = useState("");
  const navigate = useNavigate();

  const inputHandler = (e) => {
    const { name, value } = e.target;
    setBannerData((prev) => ({ ...prev, [name]: value }));
  };

  const imageHandler = (e) => {
    const file = e.target.files[0];

    if (file) {
      const allowedTypes = ["image/jpg", "image/jpeg", "image/png", "image/webp"];
      const maxSize = 2 * 1024 * 1024; // 2MB

      // Validate type
      if (!allowedTypes.includes(file.type)) {
        toast.error("Only JPG, JPEG, PNG, and WEBP files are allowed.");
        return;
      }

      // Validate size
      if (file.size > maxSize) {
        toast.error("Image size should be under 2MB.");
        return;
      }

      // Optional: Dimension check
      const img = new Image();
      const objectUrl = URL.createObjectURL(file);
      img.src = objectUrl;
      img.onload = () => {
        if (img.width > 1350 || img.height > 700) {
          toast.error("Image dimensions should not exceed 1350x700.");
          URL.revokeObjectURL(objectUrl);
          return;
        }

        setBannerData((prev) => ({ ...prev, bannerimage: file }));
        setPreviewImage(objectUrl); // Show preview
      };
    }
  };

  const submitForm = async (e) => {
    e.preventDefault();

    if (
      !bannerData.heading ||
      !bannerData.description ||
      !bannerData.bannerimage
    ) {
      toast.error("All fields, including an image, are required!");
      return;
    }

    try {
      const formData = new FormData();
      formData.append("heading", bannerData.heading);
      formData.append("description", bannerData.description);
      formData.append("bannerimage", bannerData.bannerimage);

      await axios.post("https://admin.gosaviadvanceddentalclinic.com/api/createbanner", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      toast.success("Data added successfully!");
      navigate("/");
    } catch (error) {
      console.error("Error adding banner:", error);
      toast.error("Failed to add banner!");
    }
  };

  return (
    <div className="container add-page">
      <div className="row">
        <div className="col-lg-2 col-md-2 col-sm-12" />
        <div className="col-lg-10 col-md-10 col-sm-12 add-details">
          <div className="add-banner">
            <Link to="/">
              <i className="fa-solid fa-xmark"></i>
            </Link>
            <h3>Add Banner Data</h3>
            <form
              className="row"
              onSubmit={submitForm}
              encType="multipart/form-data"
            >
              <div className="col-lg-12 col-md-12 col-sm-12 inputform">
                <label htmlFor="heading">Heading</label>
                <input
                  type="text"
                  onChange={inputHandler}
                  value={bannerData.heading}
                  id="heading"
                  name="heading"
                  placeholder="Enter Heading"
                  required
                />
              </div>
              <div className="col-lg-12 col-md-12 col-sm-12 inputform">
                <label htmlFor="description">Description</label>
                <textarea
                  onChange={inputHandler}
                  value={bannerData.description}
                  id="description"
                  name="description"
                  placeholder="Enter Description"
                  rows="4"
                  required
                ></textarea>
              </div>
              <div className="col-lg-12 col-md-12 col-sm-12 inputform">
                <label htmlFor="bannerimage">Upload Banner Image</label>
                <input
                  type="file"
                  id="bannerimage"
                  name="bannerimage"
                  accept="image/*"
                  onChange={imageHandler}
                />
                {previewImage && (
                  <img
                    src={previewImage}
                    alt="Preview"
                    style={{
                      width: "70%",
                      height: "350px",
                      borderRadius: "8px",
                      display: "block",
                      margin: "10px auto"
                    }}
                  />
                )}
              </div>
              <div className="mobilesubmitform">
                <button type="submit">Add Data</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

